<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'app',
    }
</script>
<style scoped>
</style>
<style>
    @font-face {
        font-family: 'Poppins';
        src: url('./assets/font/poppins/Poppins-Regular.otf') format('truetype');
        font-weight: normal;
    }

    @font-face {
        font-family: 'Poppins';
        src: url('./assets/font/poppins/Poppins-Bold.otf') format('truetype');
        font-weight: 700;
    }

    @font-face {
        font-family: 'Poppins';
        src: url('./assets/font/poppins/Poppins-Light.otf') format('truetype');
        font-weight: 300;
    }

    @font-face {
        font-family: 'Poppins';
        src: url('./assets/font/poppins/Poppins-SemiBold.otf') format('truetype');
        font-weight: 600;
    }

    @font-face {
        font-family: 'Poppins';
        src: url('./assets/font/poppins/Poppins-ExtraBold.otf') format('truetype');
        font-weight: 800;
    }

    body {
        margin: 0;
    }

    #app {
        font-family: 'Poppins', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        overflow: hidden;
    }

    .blueimp-gallery-display {
        display: none;
    }
</style>